import { BalanceDto } from 'api/ledger-client';

import { BalanceReportItem } from './BalanceReportItem';

export const BalanceReportList = ({
  balances,
}: {
  balances?: BalanceDto[];
}) => (
  <>
    {balances?.map((balance) => (
      <BalanceReportItem key={balance.currency} balance={balance} />
    ))}
  </>
);
